import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import { pageFetchMainURL } from "../../constant";

import Elements from "../Elements/Elements";
import corner from "../../assets/plus-step7.svg";
import ReactTooltip from "react-tooltip";
import "./StepSeven.scss";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";
import { SquareContext } from "../../SquareContext";
import cx from "classnames";

function StepSeven(props) {
  const {
    stater,
    setStater,
    setCuts2,
    setCuts,
    cuts,
    cuts2,
    jum,
    setJum,
    grooves,
    setGrooves,
    overSink,
    setOverSink,
    underSink,
    setUnderSink,
    pop,
    setPop,
    tap,
    setTap,
    hob,
    setHob,
    splash,
    setSplash,
    upst,
    setUpst,
    led,
    setLed,
    recessed,
    setRecessed,
    activeColor,
    cornerInput,
    tapInput,
    sideInput,
    sideJum,
    winInput,
    stepDesc,
    imght,
    cart,
    unity2,
    unity3,
  } = useContext(SquareContext);

  const [isVisible, setIsVisible] = useState("hidden");
  const [getHint, setGetHint] = useState([]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    fetch(`${pageFetchMainURL}/api/?turn_api=yes&show=details`)
      .then((res) => res.json())
      .then((data) => setGetHint(data));
    // .catch(err => console.log(err.message));
  }, []);

  const hint = getHint.map((el) => el.hint);

  useEffect(() => {
    if (cuts !== "0") {
      setIsVisible("flex");
      setJum(jum);
    } else {
      setIsVisible("none");
      setJum(jum);
    }
  }, [cuts, jum, setJum]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity3]);

  const handleCuts2 = (e) => setCuts2(e.target.value); // windowsills

  const handleSwitch = (a, setA) => {
    if (a === "NO") {
      setA("YES");
    } else {
      setA("NO");
    }
  };
  const handleTap = (e) => setTap(e.target.value);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepSeven">
        {stepDesc[6] && (
          <div>
            <div className="head">
              <p className="head-red">STEP 7</p>
              <p className="head-line">I</p>
              <p dangerouslySetInnerHTML={{ __html: stepDesc[6].title }}></p>
            </div>
          </div>
        )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 7) {
                props.jump(1);
              } else {
                props.jump(7);
              }
            }}
            second={() => {
              if (props.order === 7) {
                props.jump(1);
              } else {
                props.jump(7);
              }
            }}
            third={() => {
              if (props.order === 7) {
                props.jump(1);
              } else {
                props.jump(7);
              }
            }}
          />
          {stepDesc[6] !== undefined && (
            <div
              className="text-middle"
              dangerouslySetInnerHTML={{ __html: stepDesc[6].description }}
            >
              {/* <Text
                desc={stepDesc[6] !== undefined && stepDesc[6].description}
              /> */}
            </div>
          )}
          <div className="buttons">
            <button
              className="btn-prev"
              onClick={props.prev}
              style={{ background: activeColor }}
            >
              BACK STEP
            </button>
            <button
              className="btn-next"
              onClick={props.next}
              style={{ background: activeColor }}
            >
              NEXT STEP
            </button>
          </div>
        </div>
        <div className="shapes">
          <Elements eleclass="elements" />
          <div className="shapes-form-container-step7">
            <div className="det-line">
              <p>DETAILS</p>
              <hr></hr>
            </div>
            <div className="shapes-form-step7">
              <div className="detail det">
                <div className="slider-container">
                  <AwesomeSlider
                    className={cx(
                      "awesomeSlider",
                      imght[0].images.length === 1 ? "active" : ""
                    )}
                  >
                    {imght[0].images.length > 0 ? (
                      imght[0].images.map((el) => (
                        <div key={`${el}`} data-src={`${el}`} />
                      ))
                    ) : (
                      <div className="place-gray"></div>
                    )}
                  </AwesomeSlider>
                  <svg
                    className="svg-awesome"
                    // dangerouslySetInnerHTML={{__html: }}
                    data-tip={
                      hint[0] !== undefined && hint[0].replace(/&.*;/g, "")
                    }
                    id="Capa_1"
                    enableBackground="new 0 0 515.556 515.556"
                    height="512"
                    viewBox="0 0 515.556 515.556"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                  </svg>
                  <ReactTooltip place="top" type="dark" effect="solid" />
                </div>

                {/* <div className="detail-img" style={{backgroundImage: `url(${imght[0].image})`}} >
                  <svg
                    data-tip={hint[0] !== undefined && hint[0]}
                    id="Capa_1"
                    enableBackground="new 0 0 515.556 515.556"
                    height="512"
                    viewBox="0 0 515.556 515.556"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                  </svg>
                  <ReactTooltip place="top" type="dark" effect="solid" />
                </div> */}
              </div>
              <div className="detail-line">
                <div className="input-line">
                  <p>Number of rounded corners:</p>
                  <div className="input-flex">{cornerInput}</div>
                </div>
              </div>
            </div>

            {/* --------------------------------------------------1--------------------------------------------------- */}
            <div className="check-btn-container">
              <div className="check-btn-pairs">
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[1].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[1].images.length > 0 ? (
                        imght[1].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[1] !== undefined && hint[1].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Overmounted Sink</p>

                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(overSink, setOverSink)}
                      checked={overSink === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>

                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[2].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[2].images.length > 0 ? (
                        imght[2].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[2] !== undefined && hint[2].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Undermounted Sink</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(underSink, setUnderSink)}
                      checked={underSink === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
              </div>
              {/* ------------------------------------------------2--------------------------------------------------- */}
              <div className="check-btn-pairs">
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[3].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[3].images.length > 0 ? (
                        imght[3].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[3] !== undefined && hint[3].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Draining Grooves</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(grooves, setGrooves)}
                      checked={grooves === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>

                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[4].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[4].images.length > 0 ? (
                        imght[4].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[4] !== undefined && hint[4].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Recessed Area</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(recessed, setRecessed)}
                      checked={recessed === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
              </div>
              {/***********************************************Tap holes********************************** */}
              <div className="shapes-form-step7">
                <div className="detail">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[5].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[5].images.length > 0 ? (
                        imght[5].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[5] !== undefined && hint[5].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>
                </div>
                <div className="detail-line">
                  <div className="input-line-2">
                    <p>Tap Hole:</p>
                    <div className="input-flex" onChange={handleTap}>
                      {tapInput}
                    </div>
                  </div>
                </div>
              </div>

              {/* // **************************************** side panels **********************************  */}
              <div className="shapes-form-step7">
                <div className="detail sink">
                  {/* <p>NUMBER OF SINK CUT-OUTS</p> */}

                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[6].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[6].images.length > 0 ? (
                        imght[6].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[6] !== undefined && hint[6].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>
                </div>
                <div className="detail-line">
                  <div className="input-line-2">
                    {/* <hr></hr> */}
                    <p>Side Panels:</p>
                    <div className="input-flex">{sideInput}</div>
                    {/* ---------------------------jumbo - normal----------------------- */}

                    <div className="input-flex3" style={{ display: isVisible }}>
                      {sideJum}
                    </div>

                    {/* ----------------------------------------------------------------------------- */}
                  </div>
                </div>
              </div>
              {/* ******************************************windowsills *********************************** */}
              <div className="shapes-form-step7">
                <div className="detail">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[7].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[7].images.length > 0 ? (
                        imght[7].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[7] !== undefined && hint[7].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>
                </div>
                <div className="detail-line">
                  <div className="input-line-2">
                    <p>Windowsills:</p>
                    <div className="input-flex" onChange={handleCuts2}>
                      {winInput}
                    </div>
                  </div>
                </div>
              </div>
              {/* -------------------------------------------------3------------------------------------------------- */}
              <div className="check-btn-pairs">
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[8].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[8].images.length > 0 ? (
                        imght[8].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[8] !== undefined && hint[8].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Hob cut-out</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(hob, setHob)}
                      checked={hob === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[9].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[9].images.length > 0 ? (
                        imght[9].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[9] !== undefined && hint[9].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Pop-out socket cut-out</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(pop, setPop)}
                      checked={pop === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
              </div>
              {/* -------------------------------------------------4------------------------------------------------- */}
              <div className="check-btn-pairs">
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[10].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[10].images.length > 0 ? (
                        imght[10].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[10] !== undefined && hint[10].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Splashback</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(splash, setSplash)}
                      checked={splash === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[11].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[11].images.length > 0 ? (
                        imght[11].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[11] !== undefined && hint[11].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>Upstands</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(upst, setUpst)}
                      checked={upst === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
              </div>
              {/* -------------------------------------------------5------------------------------------------------- */}
              <div className="check-btn-pairs">
                <div className="check-btn-single">
                  <div className="slider-container">
                    <AwesomeSlider
                      className={cx(
                        "awesomeSlider",
                        imght[12].images.length === 1 ? "active" : ""
                      )}
                    >
                      {imght[12].images.length > 0 ? (
                        imght[12].images.map((el) => (
                          <div key={`${el}`} data-src={`${el}`} />
                        ))
                      ) : (
                        <div className="place-gray"></div>
                      )}
                    </AwesomeSlider>
                    <svg
                      className="svg-awesome"
                      data-tip={
                        hint[12] !== undefined && hint[12].replace(/&.*;/g, "")
                      }
                      id="Capa_1"
                      enableBackground="new 0 0 515.556 515.556"
                      height="512"
                      viewBox="0 0 515.556 515.556"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m257.778 0c-142.137 0-257.778 115.641-257.778 257.778s115.641 257.778 257.778 257.778 257.778-115.641 257.778-257.778-115.642-257.778-257.778-257.778zm32.222 418.889h-64.444v-64.444h64.444zm32.222-147.769-32.222 32.222v18.88h-64.444v-32.222c0-8.543 3.398-16.74 9.44-22.782l41.662-41.662c8.48-8.48 13.342-20.233 13.342-32.222 0-17.763-14.459-32.222-32.222-32.222s-32.222 14.459-32.222 32.222v32.222h-64.444v-32.222c0-53.305 43.361-96.667 96.667-96.667s96.667 43.361 96.667 96.667c-.001 29.39-11.44 57.018-32.224 77.786z" />
                    </svg>
                    <ReactTooltip place="top" type="dark" effect="solid" />
                  </div>

                  <p>LED Grooves</p>
                  <label className="switch">
                    <input
                      className="switch-input"
                      type="checkbox"
                      onChange={() => handleSwitch(led, setLed)}
                      checked={led === "YES" ? true : false}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="buttons btn-dwn7">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: activeColor }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={props.next}
                style={{ background: activeColor }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepSeven;
